module.exports = __webpack_public_path__ + "public/assets/img/sygem.svg";


//////////////////
// WEBPACK FOOTER
// ./public/assets/img/sygem.svg
// module id = 1438
// module chunks = 0